import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useSupplier, Supplier } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Supplier>
      useData={useSupplier}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
